import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_OFFICELOCATION,
  GET_OFFICELOCATION_SUCCESS,
  ADD_OFFICELOCATION,
  ADD_OFFICELOCATION_SUCCESS,
  DEL_OFFICELOCATION,
  UPDATE_OFFICELOCATION,
  DEL_OFFICELOCATION_SUCCESS,
  UPDATE_OFFICELOCATION_SUCCESS,
  DEL_OFFICELOCATION_ERROR,
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// Api Functions.
function* getOfficeLocationApi() {
  let tempArr = [];
  const response = yield api.officeLocation().getAllOfficeLocation();

  for (let i = 0; i < response.data.length; i++) {
    const { data } = response;

    tempArr.push({
      officeLocationId: data[i].officeLocationId,
      address: data[i].address,
      phoneNo: data[i].phoneNo,
      pin: data[i].pin,
      landMark: data[i].landMark,
    });
  }
  return tempArr;
}
//  add office location api.
function addOfficeLocationApi(formData) {
 const res= api.officeLocation().addEditOfficeLocation(formData);
 return res;
}
// update office location api.
function updateUpdateApi(formData) {
  api.officeLocation().addEditOfficeLocation(formData);
}
// delete office location api.
function delOfficeLocationApi(delId) {
  const response =api.officeLocation().delOfficeLocation(delId);
  return response;
}

// handle get all office location.
export function* handleGetOfficeLocation() {
  try {
    const response = yield call(getOfficeLocationApi);
    yield put({ type: GET_OFFICELOCATION_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
// handle add office location.
export function* handleAddOfficeLocation({ payload }) {
  try {

    yield call(addOfficeLocationApi, payload);
    yield put({ type: ADD_OFFICELOCATION_SUCCESS, payload: payload });
    const response = yield call(getOfficeLocationApi);
    yield put({ type: GET_OFFICELOCATION_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
// handle update office location.
export function* handleUpdateOfficeLocation({ payload }) {
  try {
    let formData = payload;

    yield call(updateUpdateApi, formData);
    yield put({ type: UPDATE_OFFICELOCATION_SUCCESS, payload: formData });
    const response = yield call(getOfficeLocationApi);
    yield put({ type: GET_OFFICELOCATION_SUCCESS, payload: response });
  } catch (error) {
     
  }
}

// handle delete office location.
export function* handleDelOfficeLocation({ payload }) {
  try {

  const respoonse=  yield call(delOfficeLocationApi, payload);
    yield put({ type: DEL_OFFICELOCATION_SUCCESS, payload: respoonse.data });
    const response = yield call(getOfficeLocationApi);
    yield put({ type: GET_OFFICELOCATION_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: DEL_OFFICELOCATION_ERROR});
     
     }
}

// watch function.
export function* officeLocationWatchFun() {
  yield takeLatest(GET_OFFICELOCATION, handleGetOfficeLocation);
  yield takeLatest(ADD_OFFICELOCATION, handleAddOfficeLocation);
  yield takeLatest(UPDATE_OFFICELOCATION, handleUpdateOfficeLocation);
  yield takeLatest(DEL_OFFICELOCATION, handleDelOfficeLocation);
}
